import { definePreset } from '@openng/optimus-ui-themes';
import Aura from '@openng/optimus-ui-themes/aura';

// CSS variables are emitted from sass/variables.scss by sass/styles.scss.
export const MockfjardsPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: 'var(--mf-primary-50)',
      100: 'var(--mf-primary-100)',
      200: 'var(--mf-primary-200)',
      300: 'var(--mf-primary-300)',
      400: 'var(--mf-primary-400)',
      500: 'var(--mf-primary-500)',
      600: 'var(--mf-primary-600)',
      700: 'var(--mf-primary-700)',
      800: 'var(--mf-primary-800)',
      900: 'var(--mf-primary-900)',
      950: 'var(--mf-primary-950)'
    },
    focusRing: {
      width: '2px',
      style: 'solid',
      color: 'var(--nightBlue)',
      offset: '3px',
      shadow: 'none'
    },
    formField: {
      paddingX: 'var(--mf-input-padding-x)',
      paddingY: 'var(--mf-input-padding-y)',
      borderRadius: 'var(--mf-input-radius)',
      focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: 'none'
      }
    },
    colorScheme: {
      light: {
        primary: {
          color: '{primary.700}',
          contrastColor: 'var(--trueWhite)',
          hoverColor: '{primary.800}',
          activeColor: '{primary.900}'
        },
        highlight: {
          background: 'var(--lightBlue)',
          focusBackground: 'var(--mf-button-hover-bg)',
          color: 'var(--nightBlue)',
          focusColor: 'var(--nightBlue)'
        },
        formField: {
          background: 'var(--trueWhite)',
          disabledBackground: 'var(--offWhite)',
          borderColor: 'var(--mf-input-border)',
          hoverBorderColor: 'var(--mediumBlue)',
          focusBorderColor: 'var(--mf-input-focus-border)',
          invalidBorderColor: 'var(--red)',
          color: 'var(--nightBlue)',
          disabledColor: 'var(--mediumGrey)',
          placeholderColor: 'var(--mediumGrey)',
          invalidPlaceholderColor: 'var(--red)',
          iconColor: 'var(--nightBlue)',
          shadow: 'none'
        },
        text: {
          color: 'var(--nightBlue)',
          hoverColor: 'var(--darkBlue)',
          mutedColor: 'var(--mediumGrey)',
          hoverMutedColor: 'var(--Grey)'
        },
        content: {
          background: 'var(--trueWhite)',
          hoverBackground: 'var(--lightOak)',
          borderColor: 'var(--mf-input-border)',
          color: 'var(--nightBlue)',
          hoverColor: 'var(--nightBlue)'
        }
      }
    }
  },
  components: {
    button: {
      root: {
        borderRadius: 'var(--mf-button-radius)',
        roundedBorderRadius: 'var(--mf-button-radius)',
        paddingX: 'var(--mf-button-padding-x)',
        paddingY: 'var(--mf-button-padding-y)',
        gap: '0.75rem',
        label: { fontWeight: '400' }
      },
      colorScheme: {
        light: {
          root: {
            primary: {
              background: 'var(--lightBlue)',
              hoverBackground: 'var(--mf-button-hover-bg)',
              activeBackground: 'var(--mediumBlue)',
              borderColor: 'var(--nightBlue)',
              hoverBorderColor: 'var(--nightBlue)',
              activeBorderColor: 'var(--nightBlue)',
              color: 'var(--nightBlue)',
              hoverColor: 'var(--nightBlue)',
              activeColor: 'var(--nightBlue)',
              focusRing: { color: 'var(--nightBlue)', shadow: 'none' }
            }
          }
        }
      }
    }
  }
});
